import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 50
    }
  }
};
export function ReviewsSection() {
  const reviews = [{
    title: 'Mi asistente personal de $19',
    quote: 'Pensé que sabía usar ChatGPT, pero los prompts de esta guía son de otro nivel. Organicé mi mes de contenidos para Instagram en una tarde. Es como tener un consultor sentado al lado mío.',
    author: 'Daniela V., Agency Owner'
  }, {
    title: 'Adiós al bloqueo mental',
    quote: 'Lo mejor es el Capítulo de Trabajo. Las propuestas que antes me tomaban toda la mañana ahora están listas antes de que termine mi café. Si valoras tu tiempo, esto es obligatorio.',
    author: 'Oscar L., Consultor Senior'
  }, {
    title: 'Sencillo y directo al grano',
    quote: 'Sin paja. Copias, pegas y funciona. Mi vida personal y mis comidas están en orden por primera vez en años. Gracias por hacerlo tan simple.',
    author: 'Mariana K., Madre y Profesional'
  }];
  return <section className="py-24 px-6 bg-navy-800 relative" data-id="element-201">
      <div className="max-w-7xl mx-auto" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-203">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-204">
            ⭐ Lo que dicen los que ya recuperaron su tiempo
          </h2>
          <div className="w-24 h-1 bg-cyan-neon mx-auto rounded-full" data-id="element-205"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-206">
          {reviews.map((review, i) => <motion.div key={i} variants={cardVariants} className="bg-[rgba(10,10,30,0.9)] border border-cyan-neon rounded-xl p-8 shadow-[0_0_30px_rgba(0,242,255,0.15)] flex flex-col h-full relative overflow-hidden group hover:shadow-[0_0_40px_rgba(0,242,255,0.25)] transition-shadow duration-300" data-id="element-207">
              {/* Subtle background glow on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-neon/0 to-cyan-neon/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-208"></div>

              <div className="flex text-gold mb-6" data-id="element-209">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-210" />)}
              </div>

              <h3 className="text-xl font-bold mb-4 bg-gradient-to-r from-purple-500 to-blue-500 bg-clip-text text-transparent" data-id="element-211">
                "{review.title}"
              </h3>

              <p className="text-slate-300 leading-relaxed mb-8 flex-grow italic" data-id="element-212">
                "{review.quote}"
              </p>

              <div className="mt-auto" data-id="element-213">
                <p className="text-cyan-neon font-semibold" data-id="element-214">
                  — {review.author}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}